module.exports = __webpack_public_path__ + "static/media/dynamic_segment.8b005c64.svg";